import Vue from './elements';
import App from './App.vue';

import VueRouter from 'vue-router';
import router from './router/router';
import store from './store/store';
import oidc from './auth/oidc';

Vue.use(VueRouter);
Vue.config.productionTip = false;

import './assets/styles/index.css';

// OIDC-Redirect zuerst abfangen (setzt localStorage.token), dann App starten.
async function boot() {
  try {
    await oidc.handleRedirectCallback();
  } catch (e) {
    console.error('OIDC-Callback:', e);
  }
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}

boot();
